import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { checkForServiceAgreement, validJobId } from '../helpers/helpers';

export const serviceAgreementGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const jobId = route.paramMap.get('jobId');
  const NO_JOB_ID_ROUTE = router.createUrlTree(['/no-job-id']);
  const NO_SERVICE_AGREEMENT_ROUTE = router.createUrlTree(['/terms', jobId]);

  if(!validJobId(jobId)) {
    return NO_JOB_ID_ROUTE;
  }

  if (!checkForServiceAgreement()) {
    return NO_SERVICE_AGREEMENT_ROUTE;
  }
  return true;
};
